var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 31.5C8.76472 31.5 6.75 29.4853 6.75 27C6.75 24.5147 8.76472 22.5 11.25 22.5C13.7353 22.5 15.75 24.5147 15.75 27C15.75 29.4853 13.7353 31.5 11.25 31.5ZM27 31.5C24.5147 31.5 22.5 29.4853 22.5 27C22.5 24.5147 24.5147 22.5 27 22.5C29.4853 22.5 31.5 24.5147 31.5 27C31.5 29.4853 29.4853 31.5 27 31.5ZM38.25 27C38.25 29.4853 40.2647 31.5 42.75 31.5C45.2353 31.5 47.25 29.4853 47.25 27C47.25 24.5147 45.2353 22.5 42.75 22.5C40.2647 22.5 38.25 24.5147 38.25 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeDotsHorizontal);
export default __webpack_public_path__ + "static/media/tree-dots-horizontal.13bc5d567136d7589b0ae7758a8120b8.svg";
export { ForwardRef as ReactComponent };